export default __webpack_public_path__ + "static/963-b2594a74d25c7eedf57c6420fb9c6ddf.gif";